import { FC, ReactElement } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { LogActionTypes, useDataLogging } from '../data-logging';

const idleTimeout = 1000 * 60 * 2; // 2 minutes

type IdleTimerProps = {
  children: ReactElement | null;
};

export const IdleTimer: FC<IdleTimerProps> = ({ children }) => {
  const log = useDataLogging();
  const handleOnActive = () => {
    log(LogActionTypes.USER_IDLE_TIME, { idleTime: getElapsedTime() });
    reset();
  };

  const { getElapsedTime, reset } = useIdleTimer({
    timeout: idleTimeout,
    onActive: handleOnActive,
    debounce: 500,
  });

  return children;
};
